/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.3.3 */
import { nothing, html } from "lit-html";
import { safeClassMap } from "@arcgis/lumina";
const CSS = {
  alignmentCenter: "internal-label-alignment--center",
  alignmentEnd: "internal-label-alignment--end",
  container: "internal-label--container",
  requiredIndicator: "internal-label-required--indicator",
  spacingBottom: "internal-label-spacing--bottom",
  spacingInlineEnd: "internal-label-spacing-inline--end",
  spacingInlineStart: "internal-label-spacing-inline--start",
  text: "internal-label--text"
};
const InternalLabel = ({ alignmentCenter, bottomSpacingDisabled, labelText, onClick, required, spacingInlineEnd, spacingInlineStart, tooltipText }) => html`<div class=${safeClassMap({
  [CSS.alignmentCenter]: alignmentCenter,
  [CSS.alignmentEnd]: !alignmentCenter,
  [CSS.container]: true,
  [CSS.spacingBottom]: !bottomSpacingDisabled,
  [CSS.spacingInlineEnd]: spacingInlineEnd,
  [CSS.spacingInlineStart]: spacingInlineStart
})} @click=${onClick}><div class=${safeClassMap(CSS.text)}>${labelText}${required && html`<span aria-hidden=true class=${safeClassMap(CSS.requiredIndicator)} title=${tooltipText ?? nothing}>*</span>` || ""}</div><slot name=label-content></slot></div>`;
export {
  InternalLabel as I
};
